import { createSlice } from "@reduxjs/toolkit";

const paymentsSlice = createSlice({
  name: "payments",
  initialState: {},
  reducers: {},
});

export default paymentsSlice.reducer;
